import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { TableData } from '@anytag/shared-types';
import { useTableMaxHeight } from '@anytag/shared-hooks';
import { SelectionBar, Button, TableV2 } from '@anytag/shared-atoms';
import { MarketplaceAffiliateJoinedInfluencer, MarketplaceDetail } from '@anytag/graphql';
import { UpdateCostsFormValues } from '../../hooks';
import { useMarketplaceJoinedInfluencersFilter } from '../MarketplaceJoinedInfluencersFilter';
import { useMarketplaceJoinedInfluencersTable } from './hooks';

export interface TemplateProps extends TableData<MarketplaceAffiliateJoinedInfluencer> {
  marketplace: MarketplaceDetail;
}
export const Template = ({ loading, data = [], marketplace }: TemplateProps) => {
  const { t } = useTranslation();
  const { filter } = useMarketplaceJoinedInfluencersFilter();
  const { formState } = useFormContext<UpdateCostsFormValues>();
  const { offsetRef, defaultTableMaxHeight } = useTableMaxHeight();
  const { columns } = useMarketplaceJoinedInfluencersTable({ data, marketplace });

  return (
    <div className="relative">
      {formState.isDirty && !loading ? (
        <SelectionBar>
          <Button
            variant="solid"
            type="submit"
            id="skipOutsideClick"
            title={t('Button.Save')}
            className="ml-auto px-4"
            loading={{ status: formState.isSubmitting, title: t('Button.Saving') }}
          />
        </SelectionBar>
      ) : null}

      <TableV2
        data={data}
        ref={offsetRef}
        loading={loading}
        columns={columns}
        rowHeight="64px"
        maxHeight={defaultTableMaxHeight}
        empty={{ description: filter.keyword ? undefined : t('Nobody joined this campaign yet') }}
        noTopBorderRadius
        stickyHeader
      />
    </div>
  );
};
